export const GOT_IT_CTA = {
    text: "Got it",
    icon: "",
};

export const TOING_PRICE_SYSTEM_ERROR_CONSTANTS = {
    title: "Oops! Looks like a technical issue on our end.",
    subtitle: "Please try uploading again in sometime.",
    icon: "TOING%20DARE%202%20COMPARE/Non%20compressed%20error/warning.png?updatedAt=1773909603639",
    errorImage:
        "TOING%20DARE%202%20COMPARE/compressed%20error/Looks%20like%20a%20technical%20hiccup%20on%20our%20end!.png?updatedAt=1773909571269",
    cta: GOT_IT_CTA,
};

export const TOING_PRICE_IMAGE_TOO_LARGE_ERROR_CONSTANTS = {
    title: "Oops! The file size is too large",
    subtitle: "Upload an image which is under 5MB",
    icon: "TOING%20DARE%202%20COMPARE/Non%20compressed%20error/warning.png?updatedAt=1773909603639",
    errorImage: "TOING%20DARE%202%20COMPARE/Non%20compressed%20error/toing.png",
    cta: GOT_IT_CTA,
};
